/**
 * @ngdoc controller
 * @name GenerateMenuController
 * @module portaro.components.main-menu
 *
 * @description
 * This controller is used by {@link directive:kpGenerateFullWidthMenu kpGenerateFullWidthMenu} and
 * {@link directive:kpGenerateSideMenu kpGenerateSideMenu} for checking user permissions.
 */
import type {MainMenuService, MenuItem} from '../main-menu.provider';
import type {ICompiledExpression, IScope} from 'angular';

export default class GenerateMenuController {

    private menuStructure;
    // eslint-disable-next-line no-empty,no-empty-function,@typescript-eslint/no-empty-function
    private onClickHandler: ICompiledExpression | (($scope: IScope) => any) = () => {
    };

    /*@ngInject*/
    constructor(private mainMenuService: MainMenuService, private $scope: IScope) {
    }

    /**
     * @ngdoc method
     * @name GenerateMenuController#setMenuStructure
     *
     * @param {Array<menuItem>} menuStructure Menu structure definition
     *
     * @description
     * This method is used for setting menu structure to controller
     */
    public setMenuStructure(menuStructure) {
        this.menuStructure = menuStructure;
    }

    /**
     * @ngdoc method
     * @name GenerateMenuController#setOnClickHandler
     *
     * @param {function} onClickHook onClick handler
     *
     * @description
     *
     */
    public setOnClickHandler(onClickHook: ICompiledExpression) {
        this.onClickHandler = onClickHook;
    }

    /**
     * @ngdoc method
     * @name GenerateMenuController#checkAuth
     *
     * @param {Event} event Click event
     * @param {number} menuIndex Index of item in main menu
     * @param {number=} submenuIndex Index of item in submenu
     *
     * @description
     * This method checks if given menuItem requires auth and user is logged. if not, prevent default event handling and triggers {@link portaro.components.main-menu.mainMenuService#requireAuthClick requireAuthClick} function.
     */
    checkAuth(event, menuIndex, submenuIndex) {
        const menuItem = this.getMenuItem(submenuIndex, menuIndex);

        if (menuItem.requiresAuth && !this.mainMenuService.isLogged()) {
            event.preventDefault();
            this.mainMenuService.requireAuthClick(menuItem, event);
        }
    }

    performClick(event, menuIndex, submenuIndex) {
        this.checkAuth(event, menuIndex, submenuIndex);

        const menuItem = this.getMenuItem(submenuIndex, menuIndex);

        this.onClickHandler(this.$scope);

        this.mainMenuService.performAction(menuItem.action);
    }

    private getMenuItem(submenuIndex, menuIndex): MenuItem {
        return submenuIndex !== void 0 ? this.menuStructure[menuIndex].submenu[submenuIndex] : this.menuStructure[menuIndex];
    }

}